import {useLexicalComposerContext} from '@lexical/react/LexicalComposerContext';
import {analyticsLogger} from 'analytics/analyticsLogger';
import {COMMAND_PRIORITY_LOW, PASTE_COMMAND} from 'lexical';
import {useEffect} from 'react';

interface PasteTrackingPluginProps {
  source?: string;
  onPaste?: () => void;
}

export const PasteTrackingPlugin = ({source, onPaste}: PasteTrackingPluginProps) => {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    return editor.registerCommand(
      PASTE_COMMAND,
      () => {
        analyticsLogger().logEvent('RICH_TEXT_AREA_PASTE', {
          source: source || 'unknown',
        });
        onPaste?.();
        return false;
      },
      COMMAND_PRIORITY_LOW
    );
  }, [editor, source, onPaste]);

  return null;
};
